import React from 'react'
import {DataGrid} from "@mui/x-data-grid";
import {useGetPurchaseTOHQuery} from "../../../core/api/toh-analytical-data-api";
import {format, subDays} from "date-fns";
import Loading from "../../../components/Common/Loading";

const columns = [

    {
        label: 'timestamp',
        field: 'timestamp',
        width: 200
    },
    {
        label: 'source',
        field: 'source',
        width: 100
    },
    {
        label: 'city',
        field: 'city',
        width: 100
    },
    {
        label: 'item',
        field: 'item',
        width: 100,
    },
    {
        label: 'product_id',
        field: 'product_id',
        width: 100
    },
    {
        label: 'amount',
        field: 'amount',
        width: 100
    },
    {
        label: 'payload',
        field: 'payload',
        width: 200
    },

]

const TohPurchaseItem = (props) => {
    console.log("TohPurchaseItem props", props)
    console.log("TohPurchaseItem date", new Date(props.date).toISOString().split('T')[0])

    const {
        data,
        isLoading,
        isSuccess,
        isError,
        isFetching,
        error
    } = useGetPurchaseTOHQuery({
        userId: props.deviceId,
        payload: props.payload !== undefined? props.payload : '',
        date: new Date(props.date).toISOString().split('T')[0],
        limit: 100,
        page: 0
    })

    let payments = ""

    if (typeof data === "object") {

        payments = <DataGrid
            getRowId={(row) => row.id}
            rows={data}
            columns={columns}
            pageSize={100}
            rowsPerPageOptions={[100]}
            autoHeight

        />
    } else {
        payments = "no data"
    }

    return (
        <Loading
            isLoading={isLoading||isFetching}
            isError={isError}
            error={error}
            isSuccess={isSuccess}
        >
            {payments}

        </Loading>
    )
}

export default TohPurchaseItem